import React from "react";
import {Tag} from "antd";
import {useTranslation} from "react-i18next";
import {TICKET_STATUS_COLORS} from "constants/ticket";

export const TicketStatusTag = ({status, darkText}) => {
    const {t} = useTranslation(["tickets"]);
    const statusColor = TICKET_STATUS_COLORS[status]?.tag || "";
    // Özel (hex) renkli etiket dolu zeminlidir ve beyaz yazı kalır; ön tanımlı renkler açık zeminli olduğundan yazı koyulaştırılabilir
    const isCustomColor = statusColor.startsWith("#");

    return (
        <Tag
            color={statusColor}
            style={darkText && !isCustomColor ? {color: "inherit"} : undefined}
        >
            {t(`statuses.${status}`, {ns: "tickets"})}
        </Tag>
    );
};
